import { Pipe, PipeTransform } from '@angular/core';
import { formatFilename } from '@emma-helpers/format.helper';

/*
 * Format filename
 * Usage:
 *   value | formatFilename
 * Example:
 *   {{ 'Hello World!' | formatFilename }}
 *   formats to: hello_world_
 */
@Pipe({
    name: 'formatFilename',
    standalone: false
})
export class FormatFilenamePipe implements PipeTransform {
  transform(value: string): string {
    return formatFilename(value);
  }
}
